import { gql } from '@apollo/client';
import { CommandeLine } from '../commandeLine/commandeline.fragments';
import { Client } from '../client/client.fragments';

export const Commande = {
  fragments: {
    main: gql`
      fragment MainCommande on Commande {
        createdAt
        fraislivraison
        methodepaiement
        numerocommande
        payment
        totalttc
        status
        prixTotal
        customerContributedToTheOng
      }
    `,
    detailsCommande: gql`
      fragment DetailsCommande on Commande {
        createdAt
        fraislivraison
        methodepaiement
        numerocommande
        customerContributedToTheOng
        payment
        totalttc
        status
        controlled
        livraison
        paymentreminder
        prixTotal
        customerContributedToTheOng
        user {
          data {
            attributes {
              firstname
              lastname
            }
          }
        }
        client {
          data {
            id
            attributes {
              ...Main
            }
          }
        }
        commandelines {
          data {
            id
            attributes {
              ...MainCommandeline
            }
          }
        }
      }

      ${CommandeLine.fragments.mainCommandeLine}
      ${Client.fragments.main}
    `
  }
};
